export const CloseIcon = () => (
  <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.053 1.053a1 1 0 011.414 0L6 4.585l3.533-3.532a1 1 0 011.32-.083l.094.083a1 1 0 010 1.414L7.415 6l3.532 3.533a1 1 0 01.083 1.32l-.083.094a1 1 0 01-1.414 0L6 7.415l-3.533 3.532a1 1 0 01-1.32.083l-.094-.083a1 1 0 010-1.414L4.585 6 1.053 2.467a1 1 0 01-.083-1.32z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);
